import moment from 'moment'

# all xxxSetting functions take an EntityCollection of settings

# login

export loginKeyBase = 'auth.login.'
export sessionKey   = loginKeyBase + 'session'
export recaptchaKey = loginKeyBase + 'recaptcha'

export sessionSetting = (settings) ->
  setting          = settings.safeFindBy(key: sessionKey)?.value or {}
  expireIn         = setting.expire_in          or 30 * 60
  expireInTerminal = setting.expire_in_terminal or  1 * 60

  { expireIn:         moment.duration(expireIn,         'seconds'), \
    expireInTerminal: moment.duration(expireInTerminal, 'seconds')  }

export recaptchaSetting = (settings) ->
  setting = settings.safeFindBy(key: recaptchaKey)?.value or {}

  enabled: (setting.enabled and setting.site_key) ? false
  siteKey: setting.site_key or null

# registration

export generalRegistrationKey = 'auth.registration'
export registrationKeyBase    = generalRegistrationKey + '.'
export tradeTermsKey          = registrationKeyBase + 'trade_terms'
export sensitiveDataKey       = registrationKeyBase + 'sensitive_data'
export emailAsUsernameKey     = registrationKeyBase + 'email_as_username'
export passwordValidationKey  = registrationKeyBase + 'password_validation'

export generalRegistrationSetting = (settings) ->
  setting = settings.safeFindBy(key: generalRegistrationKey)?.value or {}

  enabled:         setting.enabled          ? true
  disabledMessage: setting.disabled_message ? 'Registrace není povolena'

export tradeTermsSetting = (settings) ->
  setting = settings.safeFindBy(key: tradeTermsKey)?.value or {}

  { show, required, initially, link_url, link_text, checkbox_text } = setting

  show:         show          ?  true
  required:     required      ?  true
  initially:    initially     ?  false
  linkUrl:      link_url      or null
  linkText:     link_text     or 'obchodními podmínkami'
  checkboxText: checkbox_text or 'Souhlasím s obchodními podmínkami'

export sensitiveDataSetting = (settings) ->
  setting = settings.safeFindBy(key: sensitiveDataKey)?.value or {}

  { show, required, initially, link_url, link_text, checkbox_text, full_text } = setting

  show:         show          ?  true
  required:     required      ?  true
  initially:    initially     ?  false
  fullText:     full_text     or null
  linkUrl:      link_url      or null
  linkText:     link_text     or 'zpracováním osobních údajů'
  checkboxText: checkbox_text or 'Souhlasím se zpracováním osobních údajů'

export emailAsUsernameSetting = (settings) ->
  setting = settings.safeFindBy(key: emailAsUsernameKey)?.value or {}

  { checkbox, initially, always } = setting

  checkbox:  checkbox ? not always?       # should we render checkbox?
  initially: always   ? initially ? false # initial value for checkbox
  always:    always   ? false             # static value - either with read-only checkbox or with no checkbox

export passwordValidationSetting = (settings) ->
  settings.safeFindBy(key: passwordValidationKey)?.value or []
